module.exports = __webpack_public_path__ + "static/media/white-monday-gift-card.0d8dbb80.jpg";